import { render, staticRenderFns } from "./modalinterviewquestions.vue?vue&type=template&id=4c63eeea"
import script from "./modalinterviewquestions.vue?vue&type=script&lang=js"
export * from "./modalinterviewquestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports